import React, { useEffect, useState } from 'react'
import SideMenu from '../../../Components/SideDrawer'
import { Container, Form, Col, Row, Button } from 'react-bootstrap'


import PageHeader from '../../../Components/Header'
import { companyGet, employeeAdvancePostbyCompany, employeeGet } from '../../../Api/Admin/AdminApi'
import { useNavigate } from 'react-router-dom'
import { extractErrorMessage } from '../../../Utils/ErrorUtlis'


const AddAdvance = () => {
  const [organizations, setOrganizations] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [loadingCompany, setLoadingCompany] = useState(true);
  const [formData, setFormData] = useState({
    emp_id: '',
    company_id: null,
    advance_amount: null,
    advance_date: '',
    description: ''
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
          }));
          setOrganizations(companies);
          setLoadingCompany(false)
          console.log(`API Data ${JSON.stringify(organizations)}`);  // Under Production         
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchCompany()
  }, []);


  const onEmployeeget = async (id) => {
    try {
      const employees = await employeeGet(id);
      console.log("Employee data from API", employees);

      if (employees && employees.result) {
        const emp = employees.result.map(i => ({
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          team: i.team,
          team_id: i.team_id
        }));
        setEmployeeData(emp)
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);

    try {
      const response = await employeeAdvancePostbyCompany(formData);
      if (response) {
        alert('Advance Added Successfully...')
        navigate('/advance')
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'company_id') {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }))
      onEmployeeget(value)

    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title='Employee Add Advance' showButtons={true} />
        <h4 className='mb-4 d-flex justfy-content-between align-items-center'>
          Add Advance
        </h4>
        <Form onSubmit={handleSubmit} className='mt-4 align-items-center'>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId='company_id'>
              <Form.Label>Organization Name</Form.Label>
              <Form.Select
                name='company_id'
                value={formData.company_id}
                onChange={handleChange}
                required
              >
                <option value=''>Select Organization</option>
                {loadingCompany ? (<div>Loading...</div>) : (organizations.map(org => (
                  <option key={org.id} value={org.id}>{org.name}</option>
                )))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='4' controlId='emp_id'>
              <Form.Label>Employee Name</Form.Label>
              <Form.Select
                name='emp_id'
                value={formData.emp_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Employee</option>
                {employeeData.map(empl => (
                  <option key={empl.emp_id} value={empl.emp_id}>{empl.emp_name}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='4' controlId='advance_amount'>
              <Form.Label>Advance Amount</Form.Label>
              <Form.Control
                type='number'
                name='advance_amount'
                value={formData.advance_amount}
                onChange={handleChange}
                required
              >
              </Form.Control>
            </Form.Group>
          </Row>
          <Row className='mb-3'>
            <Form.Group as={Col} md="4" controlId='advance_date'>
              <Form.Label>Advance Date</Form.Label>
              <Form.Control
                type='date'
                name='advance_date'
                value={formData.advance_date}
                onChange={handleChange}
                required
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} md="8" controlId='description'>
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                type='text'
                name='description'
                value={formData.description}
                onChange={handleChange}
                required
              ></Form.Control>
            </Form.Group>
          </Row>
          <Row className='mb-3'>
            <Form.Group as={Row} className='mb-5'>
              <Col className='text-center'>
                <Button variant="primary" type="submit" className="mt-5">
                  Submit
                </Button>
              </Col>
            </Form.Group>
          </Row>
        </Form>
      </Container>
    </div>
  )
}

export default AddAdvance